import { IView } from '../types/IView';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from './Request';
import { IViewAccelerationPerf } from '../types/IViewAccelerationPerf';
import { IViewUsageInfo } from '../types/IUsageInfo';
import { IViewAccelerationStatus } from '../types/IViewAccelerationStatus';

export interface IGetWorkbookAccelerationsResult extends IGetItemsResult {
  views?: IView[];
  maxStats?: IViewUsageInfo;
  viewAccelerationPerfs?: IViewAccelerationPerf[];
  viewAccelerationStatus?: IViewAccelerationStatus[];
}

export class GetWorkbookAccelerationsRequest extends Request<IGetItemsParams, IGetWorkbookAccelerationsResult> {
  constructor(params: IGetItemsParams) {
    super('getWorkbookAccelerations', params);
  }
}